// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2":"84f1e5070542e44f","655":"65f6a862b3d5df1f","916":"9c11b9117f31de12"}[chunkId] + ".js";
};